/**
 * Legal pages (P6-01, blueprint §12.6). PLAIN-LANGUAGE DRAFTS written by engineering, NOT legal
 * advice. Before production: (1) fill the [bracketed] placeholders, (2) have them reviewed by a
 * lawyer, (3) set DRAFT to false. The refund policy is the founder's decision (docs/runbooks/billing-operations.md).
 */
export const DRAFT = true
export const EFFECTIVE = '[tanggal berlaku: isi saat rilis]'
const OPERATOR = 'Alfacode ([nama badan usaha: isi])'
const CONTACT = '[email dan WhatsApp kontak: isi]'

export type LegalDoc = { path: string; title: string; intro: string; sections: { heading: string; body: string[] }[] }

export const legalDocs: LegalDoc[] = [
  {
    path: 'syarat',
    title: 'Syarat penggunaan',
    intro: `GammaPOS adalah aplikasi kasir dan laporan untuk usaha jasa (barbershop, salon, cuci motor dan mobil), dijalankan oleh ${OPERATOR}.`,
    sections: [
      {
        heading: 'Akun dan penggunaan',
        body: [
          'Akun dibuat oleh pemilik usaha dengan kode undangan. Anda bertanggung jawab atas kerahasiaan kata sandi dan PIN, dan atas siapa yang Anda beri akses di HP kasir.',
          'Satu outlet dilayani satu HP kasir aktif pada satu waktu. Mengganti HP dilakukan dari halaman HP Kasir.',
          'Anda tidak boleh memakai GammaPOS untuk kegiatan yang melanggar hukum, atau mencoba mengakses data usaha lain.',
        ],
      },
      {
        heading: 'Yang selalu berjalan',
        body: [
          'Mencatat transaksi, membatalkan transaksi, sesi kas, mencetak struk, mengirim data ke server, dan mengunduh seluruh data Anda tetap berjalan meskipun langganan berakhir.',
        ],
      },
      {
        heading: 'Langganan',
        body: [
          'Masa percobaan 14 hari. Setelah itu langganan berbayar diperlukan untuk laporan di web, komisi staf, unduhan CSV berformat, dan riwayat lengkap di HP kasir.',
          'Setelah langganan berakhir ada masa tenggang 7 hari, lalu fitur tersebut dinonaktifkan sampai langganan diperpanjang. Satu bulan dihitung 30 hari; waktu baru ditambahkan di atas sisa waktu Anda.',
          'Pembayaran diproses oleh Midtrans. Kami tidak menyimpan nomor kartu atau data rekening Anda.',
          'Harga yang berlaku ditampilkan di halaman Langganan pada saat Anda membayar.',
        ],
      },
      {
        heading: 'Ketersediaan dan tanggung jawab',
        body: [
          'GammaPOS dirancang tetap bisa mencatat transaksi tanpa internet. Kami berusaha menjaga server tetap tersedia, tetapi tidak menjamin layanan tanpa gangguan.',
          'Angka laporan berasal dari transaksi yang dikirim HP kasir. Transaksi yang belum terkirim belum masuk laporan; status pengiriman selalu terlihat di aplikasi.',
          'Tanggung jawab kami dibatasi sebesar biaya langganan yang Anda bayar untuk periode berjalan, sejauh diizinkan hukum. [Tinjau dengan penasihat hukum.]',
        ],
      },
      {
        heading: 'Perubahan syarat',
        body: ['Jika syarat berubah secara berarti, kami memberi tahu pemilik usaha lewat web sebelum perubahan berlaku.'],
      },
      { heading: 'Kontak', body: [CONTACT] },
    ],
  },
  {
    path: 'privasi',
    title: 'Kebijakan privasi',
    intro: `Halaman ini menjelaskan data apa yang disimpan ${OPERATOR} saat Anda memakai GammaPOS, untuk apa, dan berapa lama.`,
    sections: [
      {
        heading: 'Data yang kami simpan',
        body: [
          'Akun pemilik: nama, nomor HP, dan kata sandi (disimpan dalam bentuk acak satu arah, bukan teks asli).',
          'Data usaha: nama usaha dan outlet, layanan dan harga, nama staf, aturan komisi, nama pengguna kasir dan PIN mereka (disimpan dalam bentuk acak satu arah).',
          'Transaksi: nomor struk, waktu, layanan, staf yang mengerjakan, jumlah, diskon, cara bayar, pembatalan beserta alasannya, dan sesi kas.',
          'Data teknis: model dan versi HP kasir, versi aplikasi, waktu terakhir sinkron, dan catatan perubahan penting (siapa mengubah harga, staf, komisi, atau membatalkan transaksi).',
          'Kami tidak menyimpan nama, nomor telepon, atau alamat pelanggan Anda; aplikasi ini tidak memintanya.',
        ],
      },
      {
        heading: 'Untuk apa',
        body: [
          'Menjalankan layanan: menampilkan laporan, menghitung komisi, mengganti HP kasir, dan menagih langganan.',
          'Keamanan dan bantuan: mencatat perubahan penting dan membantu Anda ketika ada masalah.',
          'Kami tidak menjual data Anda dan tidak memakainya untuk iklan.',
        ],
      },
      {
        heading: 'Pihak lain yang terlibat',
        body: [
          'Midtrans memproses pembayaran langganan dan menerima data yang diperlukan untuk itu (nama, nomor HP pemilik, nilai pembayaran).',
          'Server kami berada di penyedia hosting di [lokasi server: isi]. Pelaporan kesalahan teknis (jika diaktifkan) tidak memuat isi transaksi maupun nomor HP.',
        ],
      },
      {
        heading: 'Berapa lama',
        body: [
          'Data disimpan selama akun aktif. Setelah akun ditutup, data transaksi disimpan [90 hari: tetapkan] agar Anda sempat mengunduhnya, lalu dihapus, kecuali yang wajib kami simpan menurut hukum (catatan pembayaran).',
          'Cadangan berkala dihapus mengikuti jadwal rotasi cadangan.',
        ],
      },
      {
        heading: 'Hak Anda',
        body: [
          'Anda dapat mengunduh semua data Anda kapan saja (Pengaturan → Unduh semua data), meminta koreksi, atau meminta penghapusan akun dan data. Ajukan lewat kontak di bawah; kami menjawab dalam [14 hari kerja: tetapkan].',
        ],
      },
      { heading: 'Kontak', body: [CONTACT] },
    ],
  },
  {
    path: 'pengembalian-dana',
    title: 'Pengembalian dana dan pembatalan',
    intro: 'Kebijakan ini berlaku untuk langganan GammaPOS. [Keputusan pemilik produk: tinjau angka di bawah sebelum rilis.]',
    sections: [
      {
        heading: 'Pembatalan',
        body: [
          'Langganan tidak diperpanjang otomatis. Anda tidak perlu membatalkan apa pun: jika tidak membayar lagi, langganan berhenti pada tanggal berakhirnya.',
          'Sampai tanggal berakhir, semua fitur tetap bisa dipakai. Sesudahnya berlaku masa tenggang 7 hari, lalu fitur berbayar dinonaktifkan; pencatatan transaksi dan unduhan data tetap berjalan.',
        ],
      },
      {
        heading: 'Pengembalian dana',
        body: [
          'Waktu langganan yang sudah terpakai tidak dikembalikan dalam bentuk uang.',
          'Kami mengembalikan dana penuh bila terjadi pembayaran ganda, pembayaran yang berhasil tetapi langganan tidak aktif karena kesalahan kami, atau Anda mengajukan dalam 7 hari sejak pembayaran pertama dan belum memakai layanan berbayar. Ajukan lewat kontak di bawah dengan nomor pesanan (dimulai GP-).',
          'Dana dikembalikan lewat Midtrans ke cara bayar yang sama. Lama proses mengikuti bank atau dompet digital Anda.',
        ],
      },
      { heading: 'Kontak', body: [CONTACT] },
    ],
  },
  {
    path: 'data',
    title: 'Penyimpanan dan ekspor data',
    intro: 'Data usaha adalah milik Anda. Halaman ini menjelaskan bagaimana Anda mengambilnya dan apa yang terjadi padanya.',
    sections: [
      {
        heading: 'Ekspor kapan saja',
        body: [
          'Pengaturan → Unduh semua data memberi satu file zip berisi transaksi, rincian layanan, komisi, kas, layanan, staf, dan aturan komisi dalam CSV. Ini selalu tersedia, termasuk setelah langganan berakhir.',
          'File CSV memakai titik koma dan bisa dibuka di Excel dan Google Sheets.',
        ],
      },
      {
        heading: 'Jika HP kasir hilang atau rusak',
        body: [
          'Transaksi yang sudah terkirim aman di server. Transaksi yang belum sempat terkirim hanya ada di HP itu. Bila HP masih bisa dinyalakan, buat ekspor darurat (terkunci, hanya tim Alfacode yang bisa membukanya) dan kirim ke kami agar transaksinya dipulihkan ke laporan Anda.',
        ],
      },
      {
        heading: 'Penyimpanan',
        body: [
          'Data disimpan selama akun aktif dan mengikuti masa penyimpanan di Kebijakan privasi setelah akun ditutup.',
          'Server dicadangkan berkala; pemulihan dari cadangan tidak menghilangkan transaksi yang masih ada di HP kasir, karena HP mengirim ulang yang belum ada di server.',
        ],
      },
    ],
  },
]
